module.exports = __webpack_public_path__ + "img/img_02.999b9eaa.png";